import { CALL_INTERNAL_API } from '../../middleware/authHeaders'
import { INTERNAL_API_ROOT } from '../../config/api'

export const GET_EMAIL_LOGS_REQUEST = 'GET_EMAIL_LOGS_REQUEST'
export const GET_EMAIL_LOGS_SUCCESS = 'GET_EMAIL_LOGS_SUCCESS'
export const GET_EMAIL_LOGS_FAILURE = 'GET_EMAIL_LOGS_FAILURE'
export const RESET_EMAIL_LOGS_ERROR = 'RESET_EMAIL_LOGS_ERROR'

export const getEmailLogs = emailId => dispatch => {
  dispatch({
    [CALL_INTERNAL_API]: {
      method: 'GET',
      endpoint: `${INTERNAL_API_ROOT}/admin/search/email?search=${emailId}`,
      types: [GET_EMAIL_LOGS_REQUEST, GET_EMAIL_LOGS_SUCCESS, GET_EMAIL_LOGS_FAILURE],
    },
  })
}

export const GET_EMAIL_EVENTS_REQUEST = 'GET_EMAIL_EVENTS_REQUEST'
export const GET_EMAIL_EVENTS_SUCCESS = 'GET_EMAIL_EVENTS_SUCCESS'
export const GET_EMAIL_EVENTS_FAILURE = 'GET_EMAIL_EVENTS_FAILURE'
export const RESET_EMAIL_EVENTS_ERROR = 'RESET_EMAIL_EVENTS_ERROR'

export const getEmailEvents = eventId => dispatch => {
  dispatch({
    [CALL_INTERNAL_API]: {
      method: 'GET',
      endpoint: `${INTERNAL_API_ROOT}/admin/users/email/events/${eventId}`,
      types: [GET_EMAIL_EVENTS_REQUEST, GET_EMAIL_EVENTS_SUCCESS, GET_EMAIL_EVENTS_FAILURE],
    },
  })
}

export const RESEND_EMAIL_REQUEST = 'RESEND_EMAIL_REQUEST'
export const RESEND_EMAIL_SUCCESS = 'RESEND_EMAIL_SUCCESS'
export const RESEND_EMAIL_FAILURE = 'RESEND_EMAIL_FAILURE'

export const resendEmail = id => dispatch => {
  return dispatch({
    [CALL_INTERNAL_API]: {
      method: 'POST',
      endpoint: `${INTERNAL_API_ROOT}/admin/users/resend/email/${id}`,
      types: [RESEND_EMAIL_REQUEST, RESEND_EMAIL_SUCCESS, RESEND_EMAIL_FAILURE],
    },
  })
}

const INITIAL_STATE = {
  emailLogs: {
    results: [],
    isLoading: false,
    error: false,
  },
  emailEvents: {
    events: [],
    isLoading: false,
    error: false,
  },
}

const emailLogs = (state = INITIAL_STATE, { type, payload } = {}) =>
  ({
    [GET_EMAIL_LOGS_REQUEST]: currentState => ({
      ...currentState,
      emailLogs: {
        ...currentState.emailLogs,
        isLoading: true,
        error: false,
      },
    }),
    [GET_EMAIL_LOGS_FAILURE]: (currentState, newPayload) => ({
      ...currentState,
      emailLogs: {
        results: [],
        isLoading: false,
        error: newPayload.error,
      },
    }),
    [GET_EMAIL_LOGS_SUCCESS]: (currentState, newPayload) => ({
      ...currentState,
      emailLogs: {
        results: newPayload.results,
        isLoading: false,
        error: false,
      },
    }),
    [RESET_EMAIL_LOGS_ERROR]: currentState => ({
      ...currentState,
      emailLogs: {
        ...currentState.emailLogs,
        error: false,
      },
    }),
    [GET_EMAIL_EVENTS_REQUEST]: currentState => ({
      ...currentState,
      emailEvents: {
        ...currentState.emailEvents,
        isLoading: true,
        error: false,
      },
    }),
    [GET_EMAIL_EVENTS_FAILURE]: (currentState, newPayload) => ({
      ...currentState,
      emailEvents: {
        events: [],
        isLoading: false,
        error: newPayload.error,
      },
    }),
    [GET_EMAIL_EVENTS_SUCCESS]: (currentState, newPayload) => ({
      ...currentState,
      emailEvents: {
        events: newPayload.items,
        isLoading: false,
        error: false,
      },
    }),
    [RESET_EMAIL_EVENTS_ERROR]: currentState => ({
      ...currentState,
      emailEvents: {
        ...currentState.emailEvents,
        error: false,
      },
    }),
  }[type]?.(state, payload) || state)
export default emailLogs

export const selectLookUpEmailLogs = state => state.lookUp.emailLogs
export const selectEmailLogs = state => selectLookUpEmailLogs(state).emailLogs
export const selectEmailEvents = state => selectLookUpEmailLogs(state).emailEvents
